import React, { FC, useMemo } from 'react'
import { VStack, Image } from '@chakra-ui/react'
import { PostalCode } from '../postal-code/postal-code'
import { cardImageMap } from '../../state/interfaces'
import { setCookie } from '../../scenarios/storage'

export interface PostalCodeStandaloneProps {
  name: string
  grandImage?: string
  placeholder?: string
  onChange?: (values: string[]) => void
}

export const PostalCodeStandalone: FC<PostalCodeStandaloneProps> = ({ placeholder, name, onChange, grandImage }) => {
  const image = useMemo(() => (grandImage ? cardImageMap[grandImage] : ''), [grandImage])

  const onSubmit = (postalCode: string) => {
    if (postalCode) {
      setCookie('internetSearchPostalcode', postalCode)
      onChange && onChange([postalCode])
    }
  }

  return (
    <VStack alignItems={'center'} spacing={4} marginY={6}>
      <PostalCode onSubmit={onSubmit} name={name} placeholder={placeholder} />
      {image && <Image src={image} alt="image" width={['200px', '250px']} height={['200px', '250px']} />}
    </VStack>
  )
}
